import {
  coreExtensionData,
  createExtension,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import { ProviderSettingsItem } from '@backstage/plugin-user-settings';
import { RiStarLine } from '@remixicon/react';
import {
  bitbucketServerAuthApiRef,
  githubAuthApiRef,
  microsoftAuthApiRef,
  useApi,
  configApiRef,
} from '@backstage/core-plugin-api';
import {
  microsoftChinaAuthApiRef,
  githubEnterpriseAuthApiRef,
  githubEMUAuthApiRef,
} from '../apiRefs';

// The auth providers of this app on the Authentication Providers tab of the
// settings page. The list follows the auth API factories in `apis.tsx`.
const ProviderSettings = () => {
  const configApi = useApi(configApiRef);
  const enableGithubEnterprise = configApi.getOptionalBoolean(
    'features.enable-github-enterprise',
  );
  const enableGithubEMUGHE = configApi.getOptionalBoolean(
    'features.enable-github-emu-ghe',
  );
  return (
    <>
      <ProviderSettingsItem
        title="GitHub Enterprise Cloud"
        description="Provides authentication towards GitHub Enterprise Cloud (github.com) APIs and identities"
        apiRef={githubAuthApiRef}
        icon={<RiStarLine />}
      />
      {enableGithubEnterprise && (
        <ProviderSettingsItem
          title="GitHub Enterprise Server"
          description="Provides authentication towards GitHub Enterprise Server (git.hub.vwgroup.com) APIs and identities"
          apiRef={githubEnterpriseAuthApiRef}
          icon={<RiStarLine />}
        />
      )}
      {enableGithubEMUGHE && (
        <ProviderSettingsItem
          title="GitHub Enterprise Cloud EU (EMU)"
          description="Provides authentication towards GitHub Enterprise Cloud EU (cariad.ghe.com) APIs and identities"
          apiRef={githubEMUAuthApiRef}
          icon={<RiStarLine />}
        />
      )}
      <ProviderSettingsItem
        title="Bitbucket Server"
        description="Provides authentication towards Bitbucket Server APIs and identities"
        apiRef={bitbucketServerAuthApiRef}
        icon={<RiStarLine />}
      />
      <ProviderSettingsItem
        title="Microsoft"
        description="Provides authentication towards Microsoft APIs and identities"
        apiRef={microsoftAuthApiRef}
        icon={<RiStarLine />}
      />
      <ProviderSettingsItem
        title="MicrosoftChina"
        description="Provides authentication towards Microsoft China APIs and identities"
        apiRef={microsoftChinaAuthApiRef}
        icon={<RiStarLine />}
      />
    </>
  );
};

export const userSettingsProviderSettings = createExtension({
  name: 'provider-settings',
  attachTo: {
    id: 'sub-page:user-settings/auth-providers',
    input: 'providerSettings',
  },
  output: [coreExtensionData.reactElement],
  factory: () => [coreExtensionData.reactElement(<ProviderSettings />)],
});

export const providerSettingsModule = createFrontendModule({
  pluginId: 'user-settings',
  extensions: [userSettingsProviderSettings],
});
